module.exports = __webpack_public_path__ + "img/12.273857a.png";